import ApiService from '../../services/api.service';
import AppService from '../../services/app.service';
import OwnerModel from '../owner/owner-model';
import PersonalinfoModel from '../personalinfo/personalinfo-model';

export default class UserModel {
    id: number;
    name: string;
    useremail: string;
    useremailmasking: string;
    status: string;
    username: string;
    email: string;
    identifier: string;
    code: string;
    password: string;
    currentPassword: string;
    passwordConfirmation: string;
    confirmation: string;
    token: string;
    owner: any;
    ownerCaption: string;
    image: any;
    imageId: number; 
    imageUrl: string;
    menugroupLength: number;
    personalinfo: any;
    personalinfoCaption: string;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        if (datarow.user) datarow = {...datarow.user, code: datarow.jwt}
        this.token = datarow.code;
        this.id = datarow.id;
        this.name = datarow.name;
        this.useremail = datarow.useremail;
        this.useremailmasking = AppService.emailMasking(datarow.useremail);
        this.status = datarow.status || 'active';
        this.username = datarow.username;
        this.email = datarow.email;
        this.identifier = datarow.identifier;
        this.code = datarow.code;
        this.password = datarow.password;
        this.currentPassword = datarow.password;
        this.passwordConfirmation = datarow.password;
        this.confirmation = datarow.confirmationToken;
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name;   
        this.image = datarow.image?.[0];
        this.imageId = this.image?.id;
        this.imageUrl = this.image? ApiService.svrUrl+this.image.url : '';
        this.menugroupLength = datarow.menugroup?.length || 0;
        let personalinfo = datarow.personalinfo?.[0]? new PersonalinfoModel(datarow.personalinfo?.[0]) : datarow.personalinfo;
        this.personalinfo = personalinfo?.id;
        this.personalinfoCaption = personalinfo?.name;

    } 

    public static endPoint: string = 'users';
    public static endPointMedia: string = 'plugin::users-permissions.user';
    public static endPointAuth: string = 'auth';
    public static endPointFilterList = () => {
        const owner = OwnerModel.getOwner();
        return ( '?populate=*&sort=name&filters[owner]=' +owner);
    }     
    public static endPointFilterList2 = () => {
        return ( this.endPointFilterList() + '&filters[personalinfo][id][$null]=true')
    }
    public static url: string = '/user';
    public static caption: string = 'User';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        useremail: '',
        useremailmasking: '',
        status: 'active',
        username: '',
        email: '',
        identifier: '',
        code: '',
        password: '',
        currentPassword: '',
        passwordConfirmation: '',
        confirmation: '',
        token: '',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),
        image: null,
        imageId: 0,
        imageUrl: '',
        menugroupLength: 0,
        personalinfo: null,
        personalinfoCaption: '',
  
        }
    }

    public static defaultValueChangePassword = () => {
        return {
        password: '',
        currentPassword: '',
        passwordConfirmation: '',
        }
    }

    public static defaultValueForgotPassword = () => {
        return {
        useremail: '',
        email: '',
        }
    }

    public static defaultValueResetPassword = () => {
        return {
        code: '',
        password: '',
        passwordConfirmation: '',
        }
    }

    public static defaultValueEmailConfirmation = () => {
        return {
        confirmation: '',
        }
    }

    public static defaultValueSendEmailConfirmation = () => {
        return {
        useremail: '',
        email: '',
        }
    }

    public static defaultValueGetToken = () => {
        return {
        useremail: '',
        email: '',
        }
    }

    public static defaultValueCheckToken = () => {
        return {
        code: '',
        }
    }

    public static validations = [
        { name: 'name', nameAlias: 'User Name', required: true, minLength: 3 },
        { name: 'useremail', nameAlias: 'Email', required: true },
        { name: 'password', required: true },
        { name: 'owner', required: true },
    ]

    public static validationSignin = [
        { name: 'identifier', nameAlias: 'Email', required: true },
        { name: 'password', required: true },
    ]

    public static validationChangePassword = [
        { name: 'password', required: true },
        { name: 'currentPassword', nameAlias:'Current Password', required: true },
        { name: 'passwordConfirmation', nameAlias:'Password Confirmation', required: true },
    ]

    public static validationForgotPassword = [
        { name: 'useremail', required: true },
    ]

    public static validationResetPassword = [
        { name: 'code', nameAlias:'Verification Code', required: true },
        { name: 'password', required: true },
        { name: 'passwordConfirmation', nameAlias:'Password Confirmation', required: true },
    ]

    public static validationSendEmailConfirmation = [
        { name: 'useremail', required: true },
    ]

    public static validationEmailConfirmation = [
        { name: 'confirmation', nameAlias:'Confirmation Code', required: true },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'useremailmasking', caption: 'Email' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'useremailmasking', caption: 'Email' },
    ]    
    
    public static columnUpload = [
        { name: 'name', caption: 'Name' },
        { name: 'useremailmasking', caption: 'Email' },
        { name: 'validate', caption: 'Validation', type: 'validate', default: 'Passed' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
    public static setUser(id: string, caption: string, imageUrl: string, token: string) {
        localStorage.setItem('user', id);
        localStorage.setItem('userCaption', caption);
        localStorage.setItem('userImageUrl', imageUrl);
        localStorage.setItem('userToken', token);
        localStorage.setItem('userAppId', AppService.appId());
    }

    public static setUserPersonalinfo( id: string, caption: string) {
        localStorage.setItem('userPersonalinfo', id);
        localStorage.setItem('userPersonalinfoCaption', caption);
    }

    public static removeUser() {
        localStorage.removeItem('user');
        localStorage.removeItem('userCaption');
        localStorage.removeItem('userImageUrl');
        localStorage.removeItem('userToken');
        localStorage.removeItem('userAppId');
        localStorage.removeItem('userPersonalinfo');
        localStorage.removeItem('userPersonalinfoCaption');
    }

    public static getUser() {
        return localStorage.getItem('user') || '';
    }

    public static getUserCaption() {
        return AppService.strCapitalize(localStorage.getItem('userCaption') || '');
    }

    public static getUserAppId() {
        return localStorage.getItem('userAppId') || '';
    }

    public static getUserToken() {
        return localStorage.getItem('userToken') || '';
    }

    public static getUserImageUrl() {
        return AppService.strCapitalize(localStorage.getItem('userImageUrl') || '');
    }

    public static getUserPersonalinfo() {
        return localStorage.getItem('userPersonalinfo') || '';
    }
    
    public static getUserPersonalinfoCaption() {
        return localStorage.getItem('userPersonalinfoCaption') || '';
    }

    public static getEmailApp(userEmail: string) {
        return userEmail?.replace('@', '.app' + AppService.appId() + '@')
    }

    public static isSignin() {
        return this.getUser() !== '' && this.getUserToken() !== '' && this.getUserAppId() === AppService.appId();
    }
}